import { useMediaQuery } from 'usehooks-ts';

const useMobileLayout = () => useMediaQuery('(max-width: 767px)');

export default useMobileLayout;
